import ComplexTable from 'components/table';
import { createColumnHelper } from '@tanstack/react-table';
import { Link } from 'react-router-dom';
import Button from 'components/button';
import { HiArrowRight } from 'react-icons/hi';
import UseApi from 'hooks/useApi';
import { IFilter } from 'types';
import { encodeFilters } from 'utils';

type RowObj = {
  _id: string;
  username: number;
  createdAt: string;
};

const columnHelper = createColumnHelper<RowObj>();
const columns = [
  columnHelper.accessor('username', {
    id: 'username',
    header: () => <p className="  ">NAME</p>,
    cell: (info) => <p className="  ">{info.getValue()}</p>,
  }),
  columnHelper.accessor('createdAt', {
    id: 'date',
    header: () => <p className="  ">REGISTERATION DATE</p>,
    cell: (info) => <p className="  ">{info.getValue()?.substring(0, 10)}</p>,
  }),
  columnHelper.accessor('_id', {
    id: '_id',
    header: () => <p className="  ">DETAILS</p>,
    cell: (info) => (
      <Link key={1} to={info.getValue()}>
        <Button type="icon">
          <HiArrowRight />
        </Button>
      </Link>
    ),
  }),
];

const filters: IFilter[] = [
  { key: 'name', type: 'text', label: 'Name' },
  { key: 'createdAtFrom', type: 'date', label: 'From Date' },
  { key: 'createdAtTo', type: 'date', label: 'To Date' },
  {
    key: 'showArchived',
    type: 'select',
    options: ['false', 'true'],
    label: 'Archived',
  },
];

const AdminsTable = () => {
  const { getApi } = UseApi();

  async function fetchData(
    options: any,
    filterState: { [key: string]: string },
  ) {
    const { pageIndex, pageSize } = options;

    const response = await getApi(
      `admins?page=${pageIndex + 1}&limit=${pageSize}${encodeFilters(
        filterState,
      )}`,
    );
    const data = response.data.data.admins;
    const pageCount = response.data.data.totalPages;
    return {
      rows: data,
      pageCount,
    };
  }
  return (
    <div>
      <ComplexTable columns={columns} fetchData={fetchData} filters={filters} />
    </div>
  );
};
export default AdminsTable;
